import * as React from 'react';
import {IonButton, IonText} from '@ionic/react';

import Page from '../../../../components/core/Page';
import {Customer} from '../../../../models';
import './auto-pay-page.component.css';

type Props = {
    customer: Customer | null;
    isFetching: boolean;
    isCancelling: boolean;
    onCancel: () => void;
};

const pad2 = (n: number) => `${n}`.padStart(2, '0');

export const AutoPayPage: React.FC<Props> = props => {
    const {customer, isFetching, isCancelling, onCancel} = props;
    const autoPay = customer?.autoPay;

    const active = !!autoPay?.active;
    const available = !!autoPay?.available;
    const needsAttention = active && !!autoPay?.needsAttention;
    const paymentUrl = autoPay?.paymentUrl;

    const showSetUp = !!paymentUrl && !active;
    const showUpdateCard = !!paymentUrl && active;

    const handleGoToPaymentUrl = () => {
        if (paymentUrl) {
            window.location.href = paymentUrl;
        }
    };

    return (
        <Page className={'auto-pay-page'}
              title={'Auto-pay'}
              showMenuButton={false}
              showBackButton={true}
              backRouterLink="/settings"
              showLoading={isFetching && !customer}
        >
            <div className="ion-padding auto-pay-page-content">
                {active && (
                    <IonText>
                        <p className="auto-pay-page-status">Auto-pay is active.</p>
                    </IonText>
                )}

                {!active && available && (
                    <IonText>
                        <p className="auto-pay-page-status">
                            Set up auto-pay to keep your account paid automatically.
                        </p>
                    </IonText>
                )}

                {needsAttention && (
                    <IonText color="danger">
                        <p className="auto-pay-page-notice">
                            We couldn&apos;t charge your card. Please update your card to keep auto-pay active.
                        </p>
                    </IonText>
                )}

                {active && (autoPay?.cardBrand || autoPay?.cardLast4) && (
                    <div className="auto-pay-page-card">
                        <IonText>
                            <p className="auto-pay-page-card-number">
                                {autoPay?.cardBrand} &bull;&bull;&bull;&bull; {autoPay?.cardLast4}
                            </p>
                        </IonText>
                        {!!autoPay?.cardExpMonth && !!autoPay?.cardExpYear && (
                            <IonText color="medium">
                                <p className="auto-pay-page-card-expiry">
                                    Expires {pad2(autoPay.cardExpMonth)}/{autoPay.cardExpYear}
                                </p>
                            </IonText>
                        )}
                    </div>
                )}

                {showSetUp && (
                    <IonButton expand="block" onClick={handleGoToPaymentUrl}>
                        Set Up Auto-pay
                    </IonButton>
                )}

                {showUpdateCard && (
                    <IonButton expand="block" onClick={handleGoToPaymentUrl}>
                        Update Card
                    </IonButton>
                )}

                {active && (
                    <IonButton expand="block" fill="outline" color="danger" disabled={isCancelling} onClick={onCancel}>
                        Cancel Auto-pay
                    </IonButton>
                )}
            </div>
        </Page>
    );
};
